import React from 'react';
import styled from 'styled-components';
import { Box } from '@material-ui/core';
import { useSite } from '../../../../context/siteContext';
import { getImageURL } from '../../../../utils/getImageURL';

const Placelocation = getImageURL('/icon/placelocation.svg');
const Clock = getImageURL('/icon/clock.svg');

const Card = styled(Box)(({ theme }) => ({
  padding: '16px 0px',
  borderBottom: '0.5px solid #E0E0E0',
  display: 'flex',
  width: '100%',
  cursor: 'pointer',
}));

const Icon = styled.img(({ w, h }) => ({
  width: w,
  height: h,
}));

const CardIcon = styled.div(() => ({
  padding: 5,
  paddingLeft: 0,
}));

const Detail = styled.div(() => ({
  paddingLeft: 10,
  paddingRight: 10,
  flex: '1 1 auto',
  overflow: 'hidden',
}));

const TitleAddress = styled.div(({ theme }) => ({
  ...theme.fonts.header5,
  color: theme.colors.grey700,
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  width: '100%',
  marginBottom: 4
}));

const Address = styled.div(({ theme }) => ({
  ...theme.fonts.textS,
  color: theme.colors.grey550,
  flexGrow: 1,
  overflow: 'hidden',
  width: '100%',
  display: '-webkit-box',
  WebkitLineClamp: theme.isTabletOrMobile ? 2 : 1,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
}));

const CardLastIcon = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
}));

function ComponentAddressDetail({
  isLastUpdate,
  addressType,
  name,
  contactNo,
  isDefault,
  placeName,
  addressNumber,
  thSubDistrict,
  thDistrict,
  thProvince,
  myArea,
  myCity,
  myState,
  myDistrict,
  mySubDistrict,
  postalCode,
  country,
  onSelect,
  FirstIcon,
  LastIcon,
  Title,
  MobileDefault
}) {
  const site = useSite();
  let addressText = `${addressNumber} ${thSubDistrict}, ${thDistrict} ${thProvince} ${postalCode}`;
  if (site.MySite) {
    addressText = `${addressNumber} ${mySubDistrict ?? ''}, ${myDistrict ?? ''} ${myCity} ${myState} ${postalCode}`;
  }
  return (
    <>
      <Card>
        <CardIcon id="icon-select-address" onClick={onSelect}>
          {FirstIcon || (
            <Icon src={isLastUpdate ? Clock : Placelocation} w={20} h={20} />
          )}
        </CardIcon>
        <Detail id="content-select-address" onClick={onSelect}>
          {Title || <TitleAddress>{placeName || '-'}</TitleAddress>}
          <Address>
            {addressText}
          </Address>
          {MobileDefault}
        </Detail>
        {LastIcon && (
        <CardLastIcon>
          {' '}
          {LastIcon}
        </CardLastIcon>
        )}
      </Card>
    </>
  );
}

export default ComponentAddressDetail;
